import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=59ebcc0b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconTrash.vue"
export default component.exports